// HOOK OF INPUT 
import { UncontrolledTooltip }     from 'reactstrap'
import React, {Fragment, useState} from 'react'

const Tooltip = ({ id, name }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false),
        toggle = () => setTooltipOpen(!tooltipOpen)

  return(
    <Fragment>
      <UncontrolledTooltip isOpen={tooltipOpen} lacement="left" target={id} toggle={toggle}>
        {name}
      </UncontrolledTooltip>    
    </Fragment>
  )
}

export default Tooltip
